import { render, staticRenderFns } from "./AskedQuestions.vue?vue&type=template&id=b34f7bb0&scoped=true"
import script from "./AskedQuestions.vue?vue&type=script&lang=js"
export * from "./AskedQuestions.vue?vue&type=script&lang=js"
import style0 from "./AskedQuestions.vue?vue&type=style&index=0&id=b34f7bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34f7bb0",
  null
  
)

export default component.exports